import * as Loader from './loader'
import * as Setter from './setter'

function parseJwtToken ({ token }) {
    let parts = token.split('.')
    if (parts[1]) {
        return { userData: JSON.parse(atob(parts[1])), token }
    }
    throw new Error('unknown-result')
}

export default {
    async loadCollectionById (CollectionId) {
        return Loader.LoadCollectionById(CollectionId)
    },
    async loadCollectionCoursesById (CollectionId) {
        return Loader.LoadCollectionCoursesById(CollectionId)
    },
    async loadLearningPathCoursesBySlug (LearningPathSlug) {
        return Loader.LoadLearningPathCoursesBySlug(LearningPathSlug)
    },
    async loadNotes () {
        return Loader.loadNotes()
    },
    async loadCategories () {
        return Loader.loadCoursesCategories()
    },
    loadCategoriesByPackages () {
        return Loader.loadCategoriesByPackages()
    },
    async loadWatchLists () {
        return Loader.loadWatchlists()
    },
    async loadWatchListSubordinates () {
        return Loader.loadWatchlistSubordinates()
    },
    async loadCourses (packageId) {
        return Loader.LoadCourses(packageId)
    },
    async loadRecommendedCourses () {
        return Loader.LoadRecommendedCourses()
    },
    async loadFeaturedContent () {
        return Loader.LoadFeaturedContent()
    },
    async LoadMostPopular () {
        return Loader.LoadMostPopular()
    },
    async loadMostPopularCoursesInUsersMostPopularPackage () {
        return Loader.LoadMostPopularCoursesInUsersMostPopularPackage()
    },
    async loadCustomerSpecificCourses () {
        return Loader.LoadCustomerSpecificCourses()
    },
    async loadUpcomingDigitalClassrooms () {
        return Loader.LoadUpcomingDigitalClassrooms()
    },
    async loadUpcomingLiveEvents () {
        return Loader.LoadUpcomingLiveEvents()
    },
    async loadRecentlyAddedCourses () {
        return Loader.LoadRecentlyAddedCourses()
    },
    async loadCourseById (courseId) {
        return Loader.LoadCourseById(courseId)
    },
    async loadUserInfo () {
        return Loader.LoadUserInfo()
    },
    async loadPackageInfo () {
        return Loader.LoadPackageInfo()
    },
    async updateUserInfo (userInfo) {
        return Setter.UpdateUserInfo(userInfo)
    },
    async loadMenu () {
        return Loader.LoadMenu()
    },
    async loadVideoLogForCourseAndVideo (courseId, videoId) {
        return Loader.loadVideoLogForCourseAndVideo(courseId, videoId)
    },
    async loadVideoLogForMicroLearningElements (courseId) {
        return Loader.loadVideoLogForMicroLearningElements(courseId)
    },
    async loadCoursesForVideolog () {
        return Loader.loadCoursesForVideolog()
    },
    async loadVideologs () {
        return Loader.loadVideologs()
    },
    async loadCertificates () {
        return Loader.loadCertificates()
    },
    async loadRestrictedData () {
        return Loader.loadRestrictedData()
    },
    async loadJobTitles () {
        return Loader.loadJobTitles()
    },
    async loadCourseTestUrl (courseId) {
        return Loader.loadCourseTestUrl(courseId)
    },
    async loadAgreementForm (slug) {
        return Loader.loadAgreementForm(slug)
    },
    async loadNotification (context) {
        return Loader.loadNotification(context)
    },
    async loadDigitalClassroomSubscriptions () {
        return Loader.loadDigitalClassroomSubscriptions()
    },
    async loadUserRatings () {
        return Loader.loadUserRatings()
    },
    async loadDigitalClassRoomSignUpsForCourse (courseId) {
        return Loader.LoadDigitalClassRoomSignUpsForCourse(courseId)
    },
    async loadSubscribedLearningPaths () {
        return Loader.loadSubscribedLearningPaths()
    },
    async hideOrRestoreUncompletedLearningPathFromList ({ learningPathId, isHidden }) {
        return Setter.hideOrRestoreUncompletedLearningPathFromList({ learningPathId, isHidden })
    },
    async createWatchList (watchlistDetails, courses, collections, learningPaths) {
        return Setter.CreateWatchList(watchlistDetails, courses, collections, learningPaths)
    },
    async updateWatchList (watchlistId, watchlistDetails, courses, collections, learningPaths) {
        return Setter.UpdateWatchList(watchlistId, watchlistDetails, courses, collections, learningPaths)
    },
    async deleteWatchList (watchlistId) {
        return Setter.DeleteWatchList(watchlistId)
    },
    async shareWatchList (watchlistId, userId, mode, subordinates) {
        return Setter.ShareWatchList(watchlistId, userId, mode, subordinates)
    },
    async updateNote (noteId, content) {
        return Setter.UpdateNote(noteId, content)
    },
    async UpsertNote (courseId, content) {
        return Setter.UpsertNote(courseId, content)
    },
    async deleteNote (noteId) {
        return Setter.DeleteNote(noteId)
    },
    async login (email, password) {
        try {
            return Setter.Login(email, password)
        } catch (e) {
            throw e
        }
    },
    async requestSSOLoginUrl (serviceId) {
        return Loader.requestSSOLoginUrl(serviceId)
    },
    async loginWithSSOAuthorizationCode (code, providerId) {
        try {
            const response = await Setter.loginWithSSOAuthorizationCode(code, providerId)
            if (response.token !== undefined) {
                return parseJwtToken(response)
            } else {
                return response
            }
        } catch (e) {
            throw e
        }
    },
    async joinByToken (token) {
        return Setter.joinUsingJoinToken(token)
    },
    async saveVideoLogForCourseAndVideo (courseId, videoId, detailsObject) {
        return Setter.saveVideoLogForCourseAndVideo(courseId, videoId, detailsObject)
    },
    async logout () {
        return Setter.logout()
    },
    async changePassword (password, token) {
        return Setter.changePassword(password, token)
    },
    async changePasswordFromUserInfo (passwordInfo) {
        return Setter.ChangePasswordFromUserInfo(passwordInfo)
    },
    async changePasswordRequest (email) {
        return Setter.changePasswordRequest(email)
    },
    async sendTrial (slug, trialForm) {
        return Setter.sendTrial(slug, trialForm)
    },
    async sendFreeSubscription (formSlug, freeSubscriptionForm) {
        return Setter.sendFreeSubscription(formSlug, freeSubscriptionForm)
    },
    async sendFreeSubscriptionRequestForExisting (formSlug) {
        return Setter.sendFreeSubscriptionRequestForExisting(formSlug)
    },
    async loadFreeSubscription (slug) {
        return Loader.loadFreeSubscription(slug)
    },
    async sendAgreementRequestForNew (slug, trialForm) {
        return Setter.sendAgreementRequestForNew(slug, trialForm)
    },
    async sendAgreementRequestForExisting (slug,) {
        return Setter.sendAgreementRequestForExisting(slug)
    },
    async addNoQuizCertificate (courseId) {
        return Setter.addNoQuizCertificate(courseId)
    },
    async hideOrRestoreUncompletedCourseFromList ({ courseId, isHidden }) {
        return Setter.hideOrRestoreUncompletedCourseFromList({ courseId, isHidden })
    },
    async search (filter, abortSignal) {
        return Loader.search(filter, abortSignal)
    },
    async setUserMetadata (key, value) {
        return Setter.setMetadata(key, value)
    },
    async sendCourseRating (courseId, rating) {
        return Setter.SendCourseRating(courseId, rating)
    },
    async checkResetPasswordTokenValidity (token) {
        return Setter.checkResetPasswordTokenValidity(token)
    },
    async signUpForDigitalClassRoom (courseId, eventId) {
        return Setter.SignUpForDigitalClassRoom(courseId, eventId)
    },
    async cancelSignUpForDigitalClassRoom (courseId, eventId, subscriptionId) {
        return Setter.CancelSignUpForDigitalClassRoom(courseId, eventId, subscriptionId)
    },
    async loadSignedUpEventsForUser () {
        return Loader.LoadSignedUpEventsForUser()
    },
    async loadAllDigitalClassRoomEvents () {
        return Loader.LoadAllDigitalClassRoomEvents()
    },
    async loadSingleDigitalClassRoomEvent (eventId) {
        return Loader.LoadSingleDigitalClassRoomEvent(eventId)
    },
    async loadSingleLearningPathById (learningPathId) {
        return Loader.loadSingleLearningPathById(learningPathId)
    },
    async subscribeToLearningPath (learningPathId) {
        return Setter.subscribeToLearningPath(learningPathId)
    },
    async unSubscribeToLearningPath (learningPathId) {
        return Setter.unSubscribeToLearningPath(learningPathId)
    },
    async createLearningPathCertificate (learningPathId) {
        return Setter.createLearningPathCertificate(learningPathId)
    },
    async loadMembersForReporting (filter) {
        return Loader.LoadMembersForReporting(filter)
    },
    async loadMembersDashboardForReporting (filter) {
        return Loader.LoadMembersDashboardForReporting(filter)
    },
    async loadMemberDetailsForReporting (memberId, filter) {
        return Loader.LoadMemberDetailsForReporting(memberId, filter)
    },
    async loadCoursesForReporting (filter) {
        return Loader.LoadCoursesForReporting(filter)
    },
    async loadCoursesDashboardForReporting (filter) {
        return Loader.LoadCoursesDashboardForReporting(filter)
    },
    async downloadMembersReportingExcel (filter) {
        return Loader.DownloadMembersReportingExcel(filter)
    },
    async loadCourseDetailsForReporting (courseId, filter) {
        return Loader.LoadCourseDetailsForReporting(courseId, filter)
    },
    async downloadCoursesReportingExcel (filter) {
        return Loader.DownloadCoursesReportingExcel(filter)
    },
    async loadReportingConfiguration () {
        return Loader.LoadReportingConfiguration()
    },
    async openNewChatSession () {
        return Setter.OpenNewChatSession()
    },
    async sendMessage (chatId, message) {
        return Setter.SendMessage(chatId, message)
    },
    async loadChatSessions (chatId, message) {
        return Loader.LoadChatSessions()
    },
    async loadSingleChatHistory (chatId) {
        return Loader.LoadSingleChatHistory(chatId)
    },
    async sendChatBotFeedBack (messageId, chatId, feedbackPayload) {
        return Setter.SendChatBotFeedBack(messageId, chatId, feedbackPayload)
    },
    async loadLspSupportedFormats () {
        return Loader.LoadLspSupportedFormats()
    },
    async loadLspSupportedLanguages () {
        return Loader.LoadLspSupportedLanguages()
    },
    async downloadLspFile (courseId, courseTitle, language, format) {
        return Loader.DownloadLspFile(courseId, courseTitle, language, format)
    },
    async loadDetailedUserInfoWithPermissions () {
        let result = {}
        try {
            result = await Loader.LoadDetailedUserInfoWithPermissions()
        } catch (error) {
            console.error(`Error loading detailed user info with status code ${error.status}`)
        }
        return result
    }
}
